module.exports = __webpack_public_path__ + "prod/1.42.2/img/logo.932938dc.svg";